import React from 'react';
import TreeCheck from '../../../../../../components/TreeCheck';
import FormItem from '../FormItem/FormItem';

const TreeCheckField = ({
  form,
  label,
  name,
  decoratorOptions,
  fieldProps = {},
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem label={label}>
      {getFieldDecorator(name, {
        trigger: 'onCheck',
        valuePropName: 'checkedKeys',
        ...decoratorOptions,
      })(<TreeCheck {...fieldProps} />)}
    </FormItem>
  );
};

export default TreeCheckField;
